/*  ==============================================
//  Created by nguyendx                          ||
//  create at: 2017-10-25                        ||
//===============================================*/
import { Component, EventEmitter, Injectable, Injector, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { UploadService } from '../../../../common/services/Upload.service';
import { ConfirmationService } from 'primeng/primeng';
import { Location } from '@angular/common';
import { EvsAddressService } from '../../../../common/services/EvsAddress.service';
import { ToastrService } from 'ngx-toastr';
import { ContactService } from '../../../../common/services/Contact.service';
import { moment } from 'ngx-bootstrap/chronos/test/chain';

declare var $: any;
var that: any;
@Component({
    moduleId: module.id,
    selector: 'contact_edit',
    templateUrl: './contact_edit.component.html',
    styleUrls: ['./contact.css'],
    providers: [ConfirmationService, ContactService]
})

@Injectable()
export class ContactEditComponent implements OnInit {
    @Input('itemId') itemId: any;
    @Output('backUpdate') backUpdate = new EventEmitter();
    public contact: any = {};
    public message: { class: string, content: string } = null;
    public error: string = '';
    public cities: Array<any> = [];
    public districts: Array<any> = [];
    public componentData = null;
    public routerChange: any;

    public contact_id: number = 0;

    constructor(private injector: Injector,
        private _location: Location,
        public addressService: EvsAddressService,
        private upload: UploadService,
        private activatedRoute: ActivatedRoute,
        private _fb: FormBuilder,
        private contactService : ContactService,
        private toastr: ToastrService) {
        that = this;
    }

    ngOnInit() {
        $('#_city').select2({ placeholder: "-- Chọn Tỉnh/TP --", allowClear: false, width: '100%' }).on("select2:select", function (e) {
            $(".select2-selection__rendered").removeAttr('title');
            var id = e.target.value;
            that.loadDistrictData(id);
        });

        $('#_district').select2({ placeholder: "-- Chọn Quận/Huyện --", allowClear: false, width: '100%' })
            .on("select2:select", function (e) {
                $(".select2-selection__rendered").removeAttr('title');
            });
        $('.inputDate').datepicker({format: 'yyyy-mm-dd'});

        this.routerChange = this.activatedRoute.params.subscribe((params: Params) => {
            //this.id_store = params['id'];
            this.contact_id = this.itemId;
            this.getDetail(this.itemId);
        });
    }

    getDetail(id) {
        this.contactService.find(id).toPromise().then(res => {
            if (res) {
                if (!res.error) {
                    this.contact = res.data;
                    this.getCity();
                    $('#_sex').val(this.contact.sex).trigger('change');//set selected type
                    $('#_city').val(this.contact.city_id).trigger('change')
                    $('#_district').val(this.contact.district_id).trigger('change')
                    if(this.contact.birthday)
                        this.contact.birthday = moment(this.contact.birthday).format('YYYY-MM-DD');
                        $('#birthday').val(this.contact.birthday).trigger('change');
                } else {
                    this.message = { class: "alert dark alert-danger", content: 'Error: ' + res.message };
                }
            }
        },
            error => {
                this.message = { class: "alert dark alert-danger", content: 'Error: ' + error };
            });
    }

    backFromUpdate() {
        that.backUpdate.emit({
            isBack: true
        })
        //this._location.back();
    }

    getCity() {
        this.addressService.getCities().subscribe(res => {
            let citiesList = [];
            res.data.cities.forEach((c: any) => {
                citiesList.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
                if (c.id == this.contact.city_id) {
                    this.loadDistrictData(c.id);
                }
            });
            this.cities = citiesList;
        });
    }

    loadDistrictData(id: number) {
        this.addressService.getDistrict({ city_id: id }).toPromise().then(res => {
            let districts = [];
            res.data.districts.forEach((c: any) => {
                districts.push({
                    value: c.name,
                    label: c.name,
                    id: c.id,
                });
            });
            this.districts = districts;
        })
    }

    onSubmit(form: NgForm) {
        this.message = null;
        let objectData = {};

        let sex = $('#_sex option:selected').val();
        let city = $('#_city option:selected').val();
        let district = $('#_district option:selected').val();
        let birthday = $('#birthday').val();

        console.log(sex);
        if (this.contact.name.trim().length === 0)
            this.message = { class: "alert dark alert-danger", content: "Tên không được bỏ trống !" };
        else {
            this.processSave();

            objectData = {
                "name": this.contact.name,
                "address": this. contact.address,
                "phone": this.contact.phone,
                "email": this.contact.email,
                "facebook": this.contact.facebook,
            };
            if(sex) {
                objectData['sex'] = sex;
            }
            if(city) {
                objectData['city_id'] = city;
            }
            if(district) {
                objectData['district_id'] = district;
            }

            if(birthday) {
                objectData['birthday'] = birthday;
            }

            console.log(objectData);
            this.contactService.update(this.contact_id, objectData).subscribe(res => {
                if (res) {
                    let error = res.error;
                    if (error) {
                        this.toastr.error('Cập nhật thất bại', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                    } else {
                      
                        this.toastr.info('Cập nhật thành công !', '', {
                            timeOut: 4000,
                            positionClass: 'toast-bottom-right'
                        });
                        this.getDetail(this.contact_id);
                    }
                    this.backUpdate.emit({
                        isBack: false
                    })
                }
            }, error => {
                this.message = { class: "alert dark alert-danger", content: error.message };
            });
        }
        this.scrollToTop();
    }

    processSave() {
        this.message = {
            class: "alert dark alert-info",
            content: "Đang thực thi..."
        };
    }

    scrollToTop() {
        $("html, body").animate({ scrollTop: 0 }, "slow");
    }
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/contact/contact_edit.component.ts